export default function getExistingUserAccessOptions(access:any, projectUser:any, projectUsers:any) {
    let res = []

    if (!projectUser) projectUser = {};
    const fullAccessUsers = projectUsers ? projectUsers.findFullAccessUsers() : [];

    // if user is organization full access user he can be full access only
    if (gd.ac.check.company.isFullAccess(projectUser.userId)) {
        res = [gd.const.project.access.FULL];
    }
    // if user is owner or project manager he can be full access only...
    else if (projectUser.projectRole === gd.const.project.role.OWNER || projectUser.projectRole === gd.const.project.role.PROJECT_MANAGER) {
        res = [gd.const.project.access.FULL];
    }
    // if we have only one full access user and we are editing him - make sure only full is an option
    else if (fullAccessUsers.length === 1 && projectUser.access === gd.const.project.access.FULL) {
        res = [gd.const.project.access.FULL];
    }
    else if (projectUser.inheritance === gd.const.project.userInheritance.INHERITED) {
        let inheritedAccess = access;
        const allUserProjects = gd.session.projectUsers.filterByUser(projectUser.userId);
        const treeProject: any = gd.tree.getProject(projectUser.projectId)
        const parentProject = treeProject.parent

        const pu =_.find(allUserProjects.models, m=>m.project.id === parentProject.id);
        if (pu && pu.access < inheritedAccess) inheritedAccess = pu.access;

        if (inheritedAccess <= gd.const.project.access.FULL)                    res.push(gd.const.project.access.FULL);
        if (inheritedAccess <= gd.const.project.access.STANDARD)                res.push(gd.const.project.access.STANDARD);
        if (inheritedAccess <= gd.const.project.access.LIMITED)                 res.push(gd.const.project.access.LIMITED);
        if (inheritedAccess <= gd.const.project.access.CLIENT)                  res.push(gd.const.project.access.CLIENT);
        if (inheritedAccess <= gd.const.project.access.READ_ONLY)               res.push(gd.const.project.access.READ_ONLY);
    } else {
        res = [
            gd.const.project.access.READ_ONLY,
            gd.const.project.access.CLIENT,
            gd.const.project.access.LIMITED,
            gd.const.project.access.STANDARD,
            gd.const.project.access.FULL,
        ];
    }

    return res;
}
